export default {
  StatusDisplay: {
    f3: "F3 - Quick search",
    f9: "F9 - Quick add",
    ctrl_f2: "Ctrl F2 - View the outstanding number",
    ctrl_2: "Ctrl 2 - Copy for the back line",
    ctrl_4: "Ctrl 4 - Recalculate to unit price after tax",
    f6: "F6 - Select the code",
    f8: "F8 - Select entry voucher",
  },
  Tooltip: {
    Add: "Add (Crtl +  1)",
    Edit: "Edit (Ctrl +  E)",
    Delete: "Delete (Ctrl + D)",
    Save: "Store (Ctrl + S)",
    SaveAndAdd: "Store and add (Ctrl + Shift + S)",
    SaveAndPost: "Store and bookkeeing (Ctrl + Shift + G)",
    SaveAndPrint: "Save and print (Ctrl   Shift   P)",
    Duplicate: "Duplicate (Ctrl + Shift + C)",
    Post: "Post (Ctrl + G)",
    UnPost: "Unpost (Ctrl + Shift + G)",
    Help: "Help (F1)",
    Close: "Close (Esc)",
    Undo: "Delay (Ctrl + U)",
  },
};
